import { defineMessages } from 'react-intl';

const messages = defineMessages({
  All: 'All',
  ThisMonth: 'This month',
  ThisQuarter: 'This quarter',
  ThisYear: 'This year',
  DateFrom: 'From',
  DateUntil: 'Until',
  Today: 'Today',
  Yesterday: 'Yesterday',
  PreviousMonth: 'Previous month',
  PreviousQuarter: 'Previous quarter',
  ThisWeek: 'This week',
  PreviousWeek: 'Previous week',
  NextMonth: 'Next month',
  NextQuarter: 'Next quarter',
  LastSixMonths: 'Last 6 months',
});

export default messages;
